module.exports = __webpack_public_path__ + "media/images/pinterest-2c73f347.png";